import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';

const TrialBanner = ({ user }) => {
  const [daysRemaining, setDaysRemaining] = useState(0);
  const [hoursRemaining, setHoursRemaining] = useState(0);

  useEffect(() => {
    if (user && user.trial_end) {
      calculateTimeRemaining();
      const interval = setInterval(calculateTimeRemaining, 60000); // Update every minute
      return () => clearInterval(interval);
    }
  }, [user]);

  const calculateTimeRemaining = () => {
    if (!user || !user.trial_end) return;

    const trialEnd = new Date(user.trial_end);
    const now = new Date();
    const diff = trialEnd - now;

    if (diff > 0) {
      const days = Math.floor(diff / (1000 * 60 * 60 * 24));
      const hours = Math.floor((diff % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
      setDaysRemaining(days);
      setHoursRemaining(hours);
    } else {
      setDaysRemaining(0);
      setHoursRemaining(0);
    }
  };

  // Don't show banner if not a trial user
  if (!user || user.role !== 1 || !user.trial_end) {
    return null;
  }

  const isExpiringSoon = daysRemaining <= 1;

  return (
    <div className={`${
      isExpiringSoon ? 'bg-gradient-to-r from-red-500 to-orange-500' : 'bg-gradient-to-r from-blue-500 to-purple-600'
    } text-white py-3 px-4 shadow-lg`}>
      <div className="container mx-auto flex items-center justify-between flex-wrap gap-2">
        <div className="flex items-center gap-3">
          <span className="text-2xl">{isExpiringSoon ? '⚠️' : '🎉'}</span>
          <div>
            <p className="font-bold">
              {isExpiringSoon ? 'Trial Ending Soon!' : 'Free Trial Active'}
            </p>
            <p className="text-sm opacity-90">
              {daysRemaining > 0 ? (
                `${daysRemaining} day${daysRemaining !== 1 ? 's' : ''} and ${hoursRemaining} hour${hoursRemaining !== 1 ? 's' : ''} remaining`
              ) : (
                `${hoursRemaining} hour${hoursRemaining !== 1 ? 's' : ''} remaining`
              )}
            </p>
          </div>
        </div>
        <Link
          to="/subscription"
          className="bg-white text-blue-600 px-6 py-2 rounded-full font-bold hover:bg-gray-100 transition shadow-md"
        >
          Subscribe Now
        </Link>
      </div>
    </div>
  );
};

export default TrialBanner;
